
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { DimensionValueModel } from 'models/generated/BusinessCentral.Integration.Models.DimensionValue';
import { ItemModel } from 'models/generated/BusinessCentral.Integration.Models.Item';
import { IssuedReminderModel } from 'models/generated/BusinessCentral.Integration.Models.IssuedReminder';
import { CustomerLedgerEntryModel } from 'models/generated/BusinessCentral.Integration.Models.CustomerLedgerEntry';
import { BookedEntryModel } from 'models/generated/Economic.Integration.Clients.BookedEntriesClient.BookedEntry';
import { InvoiceObjectionModel } from 'models/generated/Entities.Accounting.InvoiceObjection';
import { BillingDocumentLineModel } from 'models/generated/Accounting.IntegrationAbstractions.BillingDocumentLine';


const _accounting_InvoicingControllerHelper = new Map<string, Object>();
_accounting_InvoicingControllerHelper.set('GetDimensionValues', DimensionValueModel);
_accounting_InvoicingControllerHelper.set('GetItems', ItemModel);
_accounting_InvoicingControllerHelper.set('GetIssuedReminders', IssuedReminderModel);
_accounting_InvoicingControllerHelper.set('GetBusinessCentralLedgerEntriesByCompany', CustomerLedgerEntryModel);
_accounting_InvoicingControllerHelper.set('GetEconomicLedgerEntriesByCompany', BookedEntryModel);
_accounting_InvoicingControllerHelper.set('GetCustomerLedgerEntriesByDocumentNos', CustomerLedgerEntryModel);
_accounting_InvoicingControllerHelper.set('GetInvoiceObjections', InvoiceObjectionModel);
_accounting_InvoicingControllerHelper.set('CreateOrUpdateInvoiceObjection', InvoiceObjectionModel);
_accounting_InvoicingControllerHelper.set('SearchInvoiceObjections', InvoiceObjectionModel);
_accounting_InvoicingControllerHelper.set('GetPostedDocumentLines', BillingDocumentLineModel);


export const accounting_InvoicingControllerHelper = _accounting_InvoicingControllerHelper;

